/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const updateProductItem3 = (componentRegistry) => {
  console.log(componentRegistry);
  componentRegistry.useComponentPlugin("ProductItem", {
    name: "customize product card",
    enabled: true,
    apply: () => ({
      afterRender(element) {
        try {
          let productData =
            element.getParams()?.props?.product ||
            element.getParams()?.props?.productData ||
            element.getParams()?.props?.data;

          let productItem = document.querySelector(
            '[data-product-id="' + productData.id + '"]'
          );
          
          if (!productItem) return;
          if (productData.vendor !== 'Profoto') return;

          let button;

          if (productItem.querySelector(".boost-sd__product-price")) {
            if (
              productData.tags.includes("call-to-order") &&
              !productItem.querySelector(".boost-sd__product-price .button") // Check for existing button
            ) {
              button = `<a href="tel:8007488200" class="button button--grey button--full" style="margin-top: 12px;">Call to Order!</a>`;
              productItem
                .querySelector(".boost-sd__product-price")
                .insertAdjacentHTML("beforeend", button);
            } else if (
              productData.tags.inclues("book-a-demo") &&
              !productItem.querySelector(".boost-sd__product-price .button") // Check for existing button
            ) {
              button = `<a href="mailto:dave@pictureline.com" class="button button--grey button--full" style="margin-top: 12px;"> Book a Demo! </a>`;
              productItem
                .querySelector(".boost-sd__product-price")
                .insertAdjacentHTML("beforeend", button);
            }
          }
        } catch (e) {
          console.error("Error customizing product card", e);
        }
      },
    }),
  });
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  updateProductItem3,
]);
